var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUmbrella(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 44,
    viewBox: "0 0 48 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.7907 1.01626C51.2986 6.08352 46.2622 13.6198 41.697 20.2471C36.273 28.1209 29.0412 43.9374 29.0412 43.9374C29.0412 43.9374 23.4163 35.2974 15.5412 30.838L13.0099 32.9807C11.3227 30.249 9.19586 27.8091 6.71377 25.7578C3.04676 22.5688 0.767774 18.0969 0.354492 13.2794C7.04951 13.44 13.7188 12.4014 20.0415 10.2137C27.5431 7.69701 40.8533 -2.04947 44.7907 1.01626Z",
    fill: "#002FA7"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7907 1.01638C44.7146 0.972787 44.6363 0.933095 44.5561 0.897461C47.2519 3.80872 46.1031 10.1212 36.4231 21.6906C31.7478 27.2783 26.6037 34.1831 24.6924 38.467C26.2661 40.1901 27.7191 42.0178 29.0412 43.9373C29.0412 43.9373 36.2732 28.1211 41.6971 20.2471C46.2623 13.6198 51.2985 6.08352 44.7907 1.01638Z",
    fill: "#219653"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.71377 25.7577C9.19595 27.8089 11.3229 30.2486 13.0104 32.9801L15.5416 30.8376C15.5416 30.8376 29.8849 18.2027 29.5096 17.2737C29.1342 16.3447 17.2923 26.0023 8.10493 23.7723C2.62729 22.4431 0.354492 13.2793 0.354492 13.2793C0.76786 18.0967 3.04683 22.5686 6.71377 25.7577Z",
    fill: "#219653"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7913 1.01641C43.3645 -0.0946497 40.6993 0.487815 37.5337 1.78807C37.3679 1.94815 37.2306 2.13482 37.1275 2.34022C36.7056 3.38539 38.6035 4.2912 38.6035 4.2912C38.6035 4.2912 36.7051 3.59445 36.213 4.50026C35.7209 5.40606 36.9864 6.45124 38.3222 6.59061C38.3222 6.59061 37.0567 6.24218 36.8462 7.42673C36.6358 8.61129 37.7603 9.44729 41.4164 10.5622C43.1709 11.1304 44.7206 12.1923 45.8765 13.6184C48.3102 8.98576 49.1857 4.43794 44.7913 1.01641Z",
    fill: "#219653"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9166 7.62963C33.4519 6.94763 31.5989 5.32129 31.5989 5.32129C31.5989 5.32129 33.6107 6.21319 34.3517 5.32129C34.823 4.75441 33.9488 4.14721 33.2477 3.77832C31.7825 4.51728 30.2864 5.3069 28.8047 6.08832C29.1042 6.48087 30.5483 8.23742 31.9166 7.62963Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6753 9.15126C27.4105 8.81127 26.8057 7.40113 26.7085 7.18506C26.1515 7.47324 25.6029 7.75194 25.0627 8.02118C25.057 8.02926 25.0395 8.04151 25.0342 8.04948C25.0342 8.04948 25.8814 9.51837 26.6753 9.15126Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7915 6.09521C28.0975 6.46141 27.4095 6.82125 26.7275 7.17476C26.8715 7.37692 28.1061 9.06557 29.0039 8.52175C29.8874 7.98686 28.9403 6.34316 28.7915 6.09521Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.2
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.51107 16.5133C9.09575 19.9435 15.2765 19.6214 20.2608 17.4261C25.2451 15.2309 26.2639 12.8087 25.5716 12.1223C24.8794 11.4359 21.7848 11.6551 16.9876 12.9456C11.9471 14.3019 9.72551 14.7424 9.51107 16.5133Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.2
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1748 31.3295C22.0354 33.1157 24.9269 31.0813 26.6597 28.5038C28.3925 25.9264 28.1357 24.4447 27.5886 24.323C27.0416 24.2013 25.6113 25.2478 23.6886 27.3306C21.6693 29.5188 20.7304 30.4076 21.1748 31.3295Z",
    fill: "white"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M7.44828 31.7778C7.44828 31.7778 -0.699414 32.7944 0.0485127 35.8933C0.796439 38.9922 7.44828 31.7778 7.44828 31.7778Z",
    fill: "#0D0D0D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M5.79267 39.1113C5.79267 39.1113 -0.185513 41.3486 0.97714 43.5523C2.13979 45.756 5.79267 39.1113 5.79267 39.1113Z",
    fill: "#0D0D0D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M25.6553 2.44457C25.6553 2.44457 18.207 -1.2221 18.207 2.44457C18.207 6.11124 25.6553 2.44457 25.6553 2.44457Z",
    fill: "#EB5757"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUmbrella);
export default __webpack_public_path__ + "static/media/Umbrella.5392b1e456e7987417df06bcb77efc63.svg";
export { ForwardRef as ReactComponent };